<template>

  <DropDownField :placeholder="t('coilToMerge')" :values="mergeableCoil" v-model="selectedCoil" />

</template>

<script setup>

import {BobineStore} from "@/stores/BobineStore";
import DropDownField from "@/components/molecules/DropDownField.vue";
import {t} from "@/utils/Traduction";
import {computed, defineEmits, defineExpose, defineProps, ref} from "vue";
import xhr from "@/utils/xhr";
import {jsonValidator} from "@/utils/JsonValidator";
import {NotificationStores} from "@/stores/NotificationStores";

const props = defineProps({
  bobine: {
    type: Object,
    required: true
  },
});

const emits = defineEmits(["onMerged"]);

const bobineStore = BobineStore();
const notificationStore = NotificationStores();

const selectedCoil = ref(-1);

const mergeableCoil = computed(() => {
  let mergeable = bobineStore.bobines.filter(b => b.uuid !== props.bobine.uuid)
    .filter(b => b.marque.uuid === props.bobine.marque.uuid && b.typeFilament.uuid === props.bobine.typeFilament.uuid && b.couleur.uuid === props.bobine.couleur.uuid);

  if(mergeable.length === 0) {
    mergeable = bobineStore.bobines.filter(b => b.uuid !== props.bobine.uuid);
  }

  return mergeable.map(b => {
    return {
      id: b.uuid  ,
      display: t('coil') + ' ' + b.nombre +  " - " + b.poidsRestant + 'g',
    }
  });
})

const merge = () => {
  xhr.addRequestToQueue("POST", `/bobines/merge/${props.bobine.uuid}/${selectedCoil.value}`, undefined, true, true, false,
      (response) => {
        if(response.code !== 200) {

          if(response.code === 0 || !jsonValidator.validate(response.response)) {
            notificationStore.addNotification(
                t("errorDuringMergeCoil"),
                "error");
          } else {
            notificationStore.addNotification(
                JSON.parse(response.response).message,
                "error");
          }
        } else {

          notificationStore.addNotification(
              t("coilMerged"),
              "success");

          const selectedBobine = bobineStore.bobines.find(b => b.uuid === selectedCoil.value);

          const keepBobine = selectedBobine.poidsRestant > props.bobine.poidsRestant ? selectedBobine : props.bobine;
          const deleteBobine = selectedBobine.poidsRestant > props.bobine.poidsRestant ? props.bobine : selectedBobine;

          bobineStore.bobines = bobineStore.bobines.filter(b => b.uuid !== deleteBobine.uuid);
          const b = bobineStore.bobines.find(b => b.uuid === keepBobine.uuid);
          b.poidsRestant = keepBobine.poidsRestant + deleteBobine.poidsRestant;

          emits("onMerged")
        }
      });
}

defineExpose({merge})

</script>

<style scoped>

</style>